import { PopImage } from '@ps/ui/atoms/pop-image';
import { cn } from '@ps/ui/utils';

interface Props {
  src?: string;
  name: string;
  size?: number;
  className?: string;
}

/**
 * Channel / member avatar. Falls back to the first letter of the
 * name on a neutral background when no image URL is provided.
 *
 * Renders via `PopImage` (unoptimized remote `<img>`) — community icons are
 * creator-uploaded and aren't in the `next/image` remotePatterns allowlist.
 */
export function ChannelAvatar({ src, name, size = 40, className }: Props) {
  const initial = name.charAt(0).toUpperCase() || '?';

  if (src) {
    return (
      <span
        className={cn(
          'bg-surface-2 relative shrink-0 overflow-hidden rounded-full',
          className,
        )}
        style={{ width: size, height: size }}
      >
        <PopImage
          src={src}
          alt={name}
          width={size}
          height={size}
          resizing={{ width: size * 3, height: size * 3 }}
          resizeMode="cover"
          className="h-full w-full"
        />
      </span>
    );
  }

  return (
    <span
      className={cn(
        'text-content-1 bg-surface-2 flex shrink-0 items-center justify-center rounded-full font-semibold',
        className,
      )}
      style={{ width: size, height: size, fontSize: Math.floor(size * 0.4) }}
      aria-hidden
    >
      {initial}
    </span>
  );
}
